import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleDetailPage from "../pages/article-detail/page";

const routes: RouteObject[] = [
  // Portuguese (default)
  { path: "/", element: <Home /> },
  { path: "/cssbuy-spreadsheet", element: <ArticlePage /> },
  { path: "/article/:slug", element: <ArticleDetailPage /> },

  // German
  { path: "/de", element: <Home /> },
  { path: "/de/cssbuy-spreadsheet", element: <ArticlePage /> },
  { path: "/de/article/:slug", element: <ArticleDetailPage /> },

  // English
  { path: "/en", element: <Home /> },
  { path: "/en/cssbuy-spreadsheet", element: <ArticlePage /> },
  { path: "/en/article/:slug", element: <ArticleDetailPage /> },

  { path: "*", element: <NotFound /> },
];

export default routes;